import { useState, useEffect } from 'react'

const getOnboardingStorageKey = (role?: 'client' | 'landlord' | 'admin') => {
  const roleKey = role || 'client'
  return `llna_onboarding_completed_${roleKey}`
}

/**
 * Hook to manage onboarding state
 * Tracks whether onboarding has been completed for a user based on their role
 */
export function useOnboarding(userRole?: 'client' | 'landlord' | 'admin') {
  const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Check if onboarding has been completed for this specific role (stored in localStorage)
    const storageKey = getOnboardingStorageKey(userRole)
    const completed = localStorage.getItem(storageKey) === 'true'
    setHasCompletedOnboarding(completed)
    setIsLoading(false)
  }, [userRole])

  const completeOnboarding = () => {
    const storageKey = getOnboardingStorageKey(userRole)
    localStorage.setItem(storageKey, 'true')
    setHasCompletedOnboarding(true)
  }

  const resetOnboarding = () => {
    const storageKey = getOnboardingStorageKey(userRole)
    localStorage.removeItem(storageKey)
    setHasCompletedOnboarding(false)
  }

  const shouldShowOnboarding = !hasCompletedOnboarding && !isLoading

  return {
    hasCompletedOnboarding,
    shouldShowOnboarding,
    completeOnboarding,
    resetOnboarding,
    isLoading
  }
}

